import { useEffect } from 'react'
import { connect } from 'react-redux'
import { openModal } from '../../actions/app'
import { isDateBefore, isValidDate, parseDateTime } from '@myap/ui-library/esm/date'

const mapStateToProps = state => {
  const {
    user: {
      data: { selectedOrgId },
    },
    settingsOrg,
  } = state
  const orgData = settingsOrg[selectedOrgId]?.data
  const expirationDate = parseDateTime(orgData?.participationForm?.dpaAgreement?.expirationDate)

  return {
    expired: isValidDate(expirationDate) && isDateBefore(expirationDate, new Date()),
  }
}

const ApAgreement = ({ expired, openModal }) => {
  useEffect(() => {
    if (expired) {
      openModal('ApAgreementModal')
    }
  }, [expired, openModal])

  return null
}

export default connect(mapStateToProps, { openModal })(ApAgreement)
